var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button button--primary",on:{"mousedown":_vm.mousedownTrigger,"click":function($event){return _vm.$emit('click')}}},[_vm._t("default"),_c('span',{staticClass:"ripple",style:(_vm.classWidth)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }